(function ($, document, window) {
  var slickslider = {
    init: function () {
      function countWidth(slides) {
        var totalWidth = 0;
        slides.each(function (index, el) {
          totalWidth += parseInt($(el).outerWidth(true), 10);
        });
        return totalWidth;
      }

      function setCommonHeight($slides) {
        var biggestHeight = 0;
        $slides.each(function (idx, el) {
          if (el.offsetHeight > biggestHeight) {
            biggestHeight = el.offsetHeight;
          }
        });
        if (biggestHeight > 0) {
          $slides.each(function (idx, el) {
            $(el).css('height', biggestHeight + 'px');
          });
        }
      }

      function serviceSlider(el) {
        var serviceSlider = $(el);
        var parent = serviceSlider.parent();
        if (parent.hasClass('compact-tiles')) {
          return;
        }
        var serviceSlides = serviceSlider.find('.c-service');
        var currentWidth = countWidth(serviceSlides);
        var maxItems = 0;

        var containerWidth = parseInt(parent.innerWidth());
        maxItems = Math.floor(containerWidth / serviceSlides.outerWidth(true));

        if (containerWidth < currentWidth) {
          serviceSlider.removeClass('is-flex');
          if (!serviceSlider.hasClass('slick-initialized')) {

            serviceSlider.slick({
              infinite: false,
              slidesToShow: maxItems,
              slidesToScroll: 1,
              swipeToSlide: true,
              arrows: false,
              variableWidth: true,
              centerMode: false,
              rows: 1,
              dots: true,
              focusOnSelect: true,
              swipe: true,
              touchMove: true,
              draggable: true,
              responsive: [
                {
                  breakpoint: 1370,
                  settings: {
                    dots: true,
                    slidesToShow: 6,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 1024,
                  settings: {
                    dots: true,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 980,
                  settings: {
                    dots: true,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    dots: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 480,
                  settings: {
                    // centerMode: true,
                    // centerPadding: '30px',
                    dots: true,
                    slidesToShow: 2.2,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
            setCommonHeight(serviceSlides);
          }
        } else if (containerWidth > currentWidth) {
          serviceSlider.addClass('is-flex');
          if (serviceSlider.hasClass('slick-initialized')) {
            serviceSlider.slick('unslick');
          }
        }
      }

      function puffSlider() {
        if ($(window).width() < 768) {
          if (!$('.js-puff-slider').hasClass('slick-initialized')) {
            $('.js-puff-slider').slick({
              infinite: false,
              slidesToShow: 4,
              arrows: false,
              // variableWidth: true,
              centerMode: true,
              rows: 1,
              dots: false,
              focusOnSelect: true,
              swipe: true,
              touchMove: true,
              draggable: true,
              responsive: [
                {
                  breakpoint: 9999,
                  settings: 'unslick',
                },
                {
                  breakpoint: 768,
                  settings: {
                    centerPadding: '30px',
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
                // {
                //   breakpoint: 480,
                //   settings: {
                //     centerPadding: '30px',
                //     dots: true,
                //     slidesToShow: 1,
                //     slidesToScroll: 1
                //   }
                // }
              ],
            });
          }
        } else if ($(window).width() > 769) {
          if ($('.js-puff-slider').hasClass('slick-initialized')) {
            $('.js-puff-slider').slick('unslick');
          }
        }
      }

      $(document).ready(function () {
        puffSlider();
        $('.js-service-slider').each(function (idx, el) {
          serviceSlider(el);
        });

      });

      var handleEqualHeightSlides = function () {
        var slickTrackHeight = $('.js-puff-slider .slick-track').height();
        $('.js-puff-slider .slick-slide').css(
          'height',
          slickTrackHeight + 'px'
        );
      };

      var reInitSlickOnResize = function () {
        handleEqualHeightSlides();
      };

      $('.c-puffs .slick-dots li button').on('click', function (e) {
        e.stopPropagation();
      });

      $(window).on('orientationchange', function () {
        reInitSlickOnResize();
        puffSlider();
      });
      $(window).on('resize', function () {
        puffSlider();
        //serviceSlider();
      });
    }, ///init
  };
  slickslider.init();
})(jQuery, document, window);
